export const PROMPT_SUGGESTIONS = [
  {
    id: 1,
    title: 'Monthly Report',
    category: 'Overview',
    prompt:
      'Generate a report of Polystox performance for this month, including users, offers, demands, bids, orders, sales, top grades, and top locations.',
  },
  {
    id: 2,
    title: 'Sales Report',
    category: 'Sales',
    prompt:
      'Show total sales, orders, average order value, top buyers, top sellers, and top-selling grades this month.',
  },
  {
    id: 3,
    title: 'Bidding Report',
    category: 'Bidding',
    prompt:
      'Generate a bidding report showing total bids, active bidders, successful bids, failed bids, top bidders, and bid-to-order conversion.',
  },
  {
    id: 4,
    title: 'New Users',
    category: 'Users',
    prompt:
      'Show new users registered this month, grouped by Buyer, Seller, Trader, and location.',
  },
  {
    id: 5,
    title: 'Buyer Report',
    category: 'Buyers',
    prompt:
      'Show top buyers by purchase value, number of orders, bids, demands, and most purchased grades.',
  },
  {
    id: 6,
    title: 'Seller Report',
    category: 'Sellers',
    prompt:
      'Show top sellers by sales value, orders, offers, bids received, and most sold grades.',
  },
  {
    id: 7,
    title: 'Order Report',
    category: 'Orders',
    prompt:
      'Show total orders by status, total order value, completed orders, cancelled orders, and average order value.',
  },
  {
    id: 8,
    title: 'Grade Analysis',
    category: 'Products',
    prompt:
      'Show the top 10 grades by offers, demands, bids, orders, quantity, and transaction value.',
  },
  {
    id: 9,
    title: 'Location Analysis',
    category: 'Geographic',
    prompt:
      'Show top buying and selling locations and identify locations with high demand but low supply.',
  },
  {
    id: 10,
    title: 'User Conversion',
    category: 'Conversion',
    prompt:
      'Analyze the funnel from new user → offer/demand → bid → order → completed transaction.',
  },
  {
    id: 11,
    title: 'Inactive Users',
    category: 'Users',
    prompt:
      'Find users who registered but have not created offers, demands, bids, or orders.',
  },
  {
    id: 12,
    title: 'Notification Report',
    category: 'Alerts',
    prompt:
      'Show notification sent, delivered, opened, clicked, and resulting orders or transactions.',
  },
  {
    id: 13,
    title: 'Price Discovery',
    category: 'Pricing',
    prompt:
      'Analyze price discovery performance from message sent → click → buy/sell intent → demand/offer → order.',
  },
  {
    id: 14,
    title: 'Month Comparison',
    category: 'Comparison',
    prompt:
      'Compare this month\'s users, bids, offers, demands, orders, and sales with last month.',
  },
  {
    id: 15,
    title: 'Business Insights',
    category: 'Insights',
    prompt:
      'Analyze Polystox data and identify the top 5 business opportunities and top 5 problems requiring attention.',
  },
  {
    id: 16,
    title: 'Full Report File',
    category: 'Full Report',
    prompt:
      'Generate a complete Polystox monthly business report with charts, tables, KPIs, insights, and recommendations as a report file.',
  },
];

export const PROMPT_CATEGORIES = [
  'All',
  'Overview',
  'Sales',
  'Bidding',
  'Users',
  'Products',
  'Insights',
];
